module.exports = __webpack_public_path__ + "static/kobe-bryant-3fb0a8359a584f04df7bb4ef8b599758.jpeg";